module.exports = __webpack_public_path__ + "img/dribbble.124a5e90.svg";